import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedModelAction, updateModelAction } from '../../../redux/actions/modelsActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import ModelForm from '../forms/ModelForm';

const UpdateModelModal = ({ readOnly, onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const brandId = useSelector((state) => state.models.brand?.id);
  const model = useSelector((state) => state.models?.model);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(updateModelAction(data, brandId));
    await dispatch(clearSelectedModelAction());
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Змінити модель'}
      loading={loading}
      onClose={onModalClose}
      body={<ModelForm readOnly={readOnly} onSubmit={onSubmit} loading={loading} initModel={model} />}
      actionButton={
        !readOnly && (
          <Button type={'submit'} disabled={loading} variant={'primary'} formId={'model-form'} children={'Змінити'} />
        )
      }
    />
  );
};

export default UpdateModelModal;
